const PaywallView = () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/PaywallView.vue')

export const paywallInstances = [
	{
		id: 'email',
		name: 'plan-email', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email'),
	},
	{
		id: 'email-assessment',
		name: 'plan-email-assessment',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-assessment'),
	},
	{
		id: 'email-f',
		name: 'plan-email-female', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-female'),
	},
	{
		id: 'email-f-commitment',
		name: 'plan-email-female-commitment', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-female-commitment'),
	},
	{
		id: 'email-activity',
		name: 'plan-email-activity', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-activity'),
	},
	{
		id: 'email-activity-m',
		name: 'plan-email-activity-male', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-activity-male'),
	},
	{
		id: 'email-pilates',
		name: 'plan-email-pilates', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-pilates'),
	},
	{
		id: 'email-pilates-commitment',
		name: 'plan-email-pilates-commitment', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-pilates-commitment'),
	},
	{
		id: 'email-yoga',
		name: 'plan-email-yoga', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-yoga'),
	},
	{
		id: 'email-yoga-m',
		name: 'plan-email-yoga-male', // Don't rename
		config: () =>
			import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-male-activity-chair-yoga'),
	},
	{
		id: 'email-chair-workouts-m',
		name: 'plan-email-chair-workouts-m', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-chair-workouts-m'),
	},
	{
		id: 'email-somatic-yoga',
		name: 'plan-email-somatic-yoga', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-somatic-yoga'),
	},
	{
		id: 'email-walking-f',
		name: 'plan-email-walking', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-walking'),
	},
	{
		id: 'email-walking-m',
		name: 'plan-email-walking-male', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-walking-male'),
	},
	{
		id: 'email-hiit-f',
		name: 'plan-email-hiit-f', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-hiit-f'),
	},
	{
		id: 'email-hiit-m',
		name: 'plan-email-hiit-male', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-hiit-m'),
	},
	{
		id: 'email-calisthenics-m',
		name: 'plan-email-calisthenics-male', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-calisthenics-m'),
	},
	{
		id: 'email-one-click-purchase',
		name: 'plan-email-one-click-purchase', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-one-click-purchase'),
	},
	{
		id: 'email-calisthenics-f',
		name: 'plan-email-calisthenics-female', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-calisthenics-f'),
	},
	{
		id: 'email-menopause-f',
		name: 'plan-email-menopause-female', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-menopause-f'),
	},
	{
		id: 'email-one-click-m',
		name: 'plan-email-one-click-male', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/one-click/email-one-click-m'),
	},
	{
		id: 'email-one-click-f',
		name: 'plan-email-one-click-female', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/one-click/email-one-click-f'),
	},
	{
		id: 'email-barre-f',
		name: 'plan-email-barre-f', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-barre-f'),
	},
	{
		id: 'email-cortisol-f',
		name: 'plan-email-cortisol-f', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-cortisol-f'),
	},
	{
		id: 'email-glp-f',
		name: 'plan-email-glp-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-glp-f'),
	},
	{
		id: 'email-fsa-hsa',
		name: 'plan-email-fsa-hsa',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-fsa-hsa'),
	},
	{
		id: 'email-black-friday-early-birds-m',
		name: 'plan-email-black-friday-early-birds-m', // Don't rename
		config: () =>
			import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-black-friday-early-birds-m'),
	},
	{
		id: 'email-black-friday-early-birds-f',
		name: 'plan-email-black-friday-early-birds-f', // Don't rename
		config: () =>
			import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-black-friday-early-birds-f'),
	},
	{
		id: 'email-black-friday-blinky-f',
		name: 'plan-email-black-friday-blinky-f', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-black-friday-blinky-f'),
	},
	{
		id: 'email-black-friday-blinky-m',
		name: 'plan-email-black-friday-blinky-m', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-black-friday-blinky-m'),
	},
	{
		id: 'email-black-friday-blinky-second-f',
		name: 'plan-email-black-friday-blinky-second-f', // Don't rename
		config: () =>
			import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-black-friday-blinky-second-f'),
	},
	{
		id: 'email-black-friday-blinky-second-m',
		name: 'plan-email-black-friday-blinky-second-m', // Don't rename
		config: () =>
			import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-black-friday-blinky-second-m'),
	},
	{
		id: 'email-black-friday-spin-and-win-m',
		name: 'plan-email-black-friday-spin-and-win-m', // Don't rename
		config: () =>
			import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-black-friday-spin-and-win-m'),
	},
	{
		id: 'email-black-friday-spin-and-win-f',
		name: 'plan-email-black-friday-spin-and-win-f', // Don't rename
		config: () =>
			import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-black-friday-spin-and-win-f'),
	},
	{
		id: 'email-black-friday-planet-offer-m',
		name: 'plan-email-black-friday-planet-offer-m', // Don't rename
		config: () =>
			import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-black-friday-planet-offer-m'),
	},
	{
		id: 'email-black-friday-planet-offer-f',
		name: 'plan-email-black-friday-planet-offer-f', // Don't rename
		config: () =>
			import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-black-friday-planet-offer-f'),
	},
	{
		id: 'email-black-friday-last-day-m',
		name: 'plan-email-black-friday-last-day-m', // Don't rename
		config: () =>
			import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-black-friday-last-day-m'),
	},
	{
		id: 'email-black-friday-last-day-f',
		name: 'plan-email-black-friday-last-day-f', // Don't rename
		config: () =>
			import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-black-friday-last-day-f'),
	},
	{
		id: 'email-black-friday-cyber-monday-m',
		name: 'plan-email-black-friday-cyber-monday-m', // Don't rename
		config: () =>
			import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-black-friday-cyber-monday-m'),
	},
	{
		id: 'email-black-friday-cyber-monday-f',
		name: 'plan-email-black-friday-cyber-monday-f', // Don't rename
		config: () =>
			import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-black-friday-cyber-monday-f'),
	},
	{
		id: 'email-black-friday-cyber-monday-second-m',
		name: 'plan-email-black-friday-cyber-monday-second-m', // Don't rename
		config: () =>
			import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-black-friday-cyber-monday-second-m'),
	},
	{
		id: 'email-black-friday-cyber-monday-second-f',
		name: 'plan-email-black-friday-cyber-monday-second-f', // Don't rename
		config: () =>
			import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-black-friday-cyber-monday-second-f'),
	},
	{
		id: 'in-app',
		name: 'plan-in-app', // Don't rename
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/in-app'),
	},
	{
		id: 'main',
		name: 'plan-main',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/main'),
	},
	{
		id: 'm',
		name: 'plan-m',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/m'),
	},
	{
		id: 'm-eu',
		name: 'plan-m-eu',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/m-eu'),
	},
	{
		id: 'm-free',
		name: 'plan-m-free',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/free/m-free'),
	},
	{
		id: 'f',
		name: 'plan-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/f'),
	},
	{
		id: 'f-us',
		name: 'plan-f-us',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/commitment/f-us'),
	},
	{
		id: 'f-al',
		name: 'plan-f-al',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/commitment/f-al'),
	},
	{
		id: 'f-eu',
		name: 'plan-f-eu',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/f-eu'),
	},
	{
		id: 'f-br',
		name: 'plan-f-br',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/f-br'),
	},
	{
		id: 'f-commitment',
		name: 'plan-f-commitment',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/commitment/f-commitment'),
	},
	{
		id: 'f-free',
		name: 'plan-f-free',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/free/f-free'),
	},
	{
		id: 'activity-f',
		name: 'plan-activity-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/activity-f'),
	},
	{
		id: 'activity-f-eu',
		name: 'plan-activity-f-eu',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/activity-f-eu'),
	},
	{
		id: 'activity-m',
		name: 'plan-activity-m',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/activity-m'),
	},
	{
		id: 'activity-m-eu',
		name: 'plan-activity-m-eu',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/activity-m-eu'),
	},
	{
		id: 'pilates-f',
		name: 'plan-pilates-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/pilates-f'),
	},
	{
		id: 'pilates-f-commitment',
		name: 'plan-pilates-f-commitment',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/commitment/pilates-f-commitment'),
	},
	{
		id: 'pilates-f-commitment-us',
		name: 'plan-pilates-f-commitment-us',
		config: () =>
			import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/bill_in_weeks/pilates-f-commitment-us'),
	},
	{
		id: 'pilates-f-al',
		name: 'plan-pilates-f-al',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/bill_in_weeks/pilates-f-al'),
	},
	{
		id: 'yoga-f',
		name: 'plan-yoga-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/yoga-f'),
	},
	{
		id: 'yoga-f-eu',
		name: 'plan-yoga-f-eu',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/yoga-f-eu'),
	},
	{
		id: 'yoga-f-al',
		name: 'plan-yoga-f-al',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/bill_in_weeks/yoga-f-al'),
	},
	{
		id: 'yoga-m',
		name: 'plan-yoga-m',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/yoga-m'),
	},
	{
		id: 'chair-workouts-m',
		name: 'plan-chair-workouts-m',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/chair-workouts-m'),
	},
	{
		id: 'yoga-m-us',
		name: 'plan-yoga-m-us',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/bill_in_weeks/yoga-m-us'),
	},
	{
		id: 'yoga-m-eu',
		name: 'plan-yoga-m-eu',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/yoga-m-eu'),
	},
	{
		id: 'somatic-yoga-f',
		name: 'plan-somatic-yoga-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/somatic-yoga-f'),
	},
	{
		id: 'somatic-yoga-f-eu',
		name: 'plan-somatic-yoga-f-eu',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/somatic-yoga-f-eu'),
	},
	{
		id: 'walking-f',
		name: 'plan-walking-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/walking-f'),
	},
	{
		id: 'walking-f-free',
		name: 'plan-walking-f-free',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/free/walking-f-free'),
	},
	{
		id: 'printable-walking-f',
		name: 'plan-printable-walking-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/printable-walking-f'),
	},
	{
		id: 'walking-f-us',
		name: 'plan-walking-f-us',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/bill_in_weeks/walking-f-us'),
	},
	{
		id: 'walking-f-al',
		name: 'plan-walking-f-al',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/bill_in_weeks/walking-f-al'),
	},
	{
		id: 'walking-f-eu',
		name: 'plan-walking-f-eu',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/walking-f-eu'),
	},
	{
		id: 'tai-chi-walking-f-v2',
		name: 'plan-tai-chi-walking-f-v2',
		config: () =>
			import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/bill_in_weeks/tai-chi-walking-f-v2'),
	},
	{
		id: 'walking-m',
		name: 'plan-walking-m',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/walking-m'),
	},
	{
		id: 'walking-m-free',
		name: 'plan-walking-m-free',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/free/walking-m-free'),
	},
	{
		id: 'walking-m-us',
		name: 'plan-walking-m-us',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/bill_in_weeks/walking-m-us'),
	},
	{
		id: 'walking-m-eu',
		name: 'plan-walking-m-eu',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/walking-m-eu'),
	},
	{
		id: 'tai-chi-yoga-m',
		name: 'plan-tai-chi-yoga-m',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/tai-chi-yoga-m'),
	},
	{
		id: 'email-tai-chi-yoga-m',
		name: 'plan-email-tai-chi-yoga-male',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-tai-chi-yoga-m'),
	},
	{
		id: 'f-activity-s',
		name: 'plan-f-activity-s',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/f-activity-s'),
	},
	{
		id: 'm-activity-s',
		name: 'plan-m-activity-s',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/m-activity-s'),
	},
	{
		id: 'm-activity-s-us',
		name: 'plan-m-activity-s-us',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/bill_in_weeks/m-activity-s-us'),
	},
	{
		id: 'hiit-f',
		name: 'plan-hiit-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/hiit-f'),
	},
	{
		id: 'hiit-m',
		name: 'plan-hiit-m',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/hiit-m'),
	},
	{
		id: 'calisthenics-m',
		name: 'plan-calisthenics-m',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/calisthenics-m'),
	},
	{
		id: 'calisthenics-f',
		name: 'plan-calisthenics-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/calisthenics-f'),
	},
	{
		id: 'menopause-f',
		name: 'plan-menopause-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/menopause-f'),
	},
	{
		id: 'barre-f',
		name: 'plan-barre-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/barre-f'),
	},
	{
		id: 'cortisol-f',
		name: 'plan-cortisol-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/cortisol-f'),
	},
	{
		id: 'walking-japanese-f',
		name: 'plan-walking-japanese-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/walking-japanese-f'),
	},
	{
		id: 'email-walking-japanese',
		name: 'plan-email-walking-japanese',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/crm/email-walking-japanese'),
	},
	{
		id: 'glp-f',
		name: 'plan-glp-f',
		config: () => import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/commitment/glp-f'),
	},
]

const paywallRoutesList = paywallInstances.map((instance) => ({
	path: `/plan/${instance.id}`,
	name: instance.name,
	component: {
		render: (h) =>
			h(PaywallView, {
				key: instance.id,
				props: {
					id: instance.id,
					config: instance.config,
				},
			}),
	},
	meta: {
		pageAnalyticUxEvent: {
			name: 'ScreenView',
			data: {
				title: 'OnboardingCreatedProgramScreen',
			},
		},
	},
}))

export default paywallRoutesList
